export const APPROVAL_REWARDS_ENDPOINTS = {
  GET_APPROVAL_REWARDS_COUNT: 'api/v1/badge/assignments/admin/rewards',
  UPDATE_APPROVAL_STATUS: 'api/v1/badge/assignments/admin/update-approval/',
  GET_PENDING_REWARDS_LIST: 'api/v1/badge/assignments/admin/pending-approval',
  GET_APPROVAL_REWARDS_LIST: 'api/v1/badge/assignments/admin/approval-rewards',

  GET_EMPLOYEE_APPROVAL_REWARDS_LIST: 'api/v1/badge/assignments/employee/approval-rewards'
}